import pick from 'lodash/pick'
import { AnyAction } from 'redux'

import { TRACK } from '../constants'
import instrumentAction from '../instrumentAction'

type TrackerFunction = (
    action: AnyAction,
    payload?: Record<string, any>,
) => ReturnType<typeof instrumentAction>
export const registry: Record<string, TrackerFunction> = {}

function buildTracker(eventName: string, schema: string[] = []) {
    registry[eventName] = (action, payload = {}) => {
        // Instrument this action with the TRACK analytics type
        // passing in a payload of 'event' and 'properties'.
        //
        // See https://segment.com/docs/spec/track/#event for where
        // we get 'event' and 'properties' as the analytics payload.
        return instrumentAction(action, TRACK, {
            event: eventName,
            properties: pick(payload, schema),
        })
    }
    return registry[eventName]
}

// Event names should be capital case,
// use a past-tense verb and a noun, and be human readable.
// See https://segment.com/docs/spec/track/#event

// ------------- Consumer application related events -----------------
const UPLOADED_PART = 'Uploaded part'
const OPENED_CHAT = 'Opened chat'
const OPENED_MODAL = 'Opened modal'

const PART_SCHEMA = ['partId']
const MODAL_SCHEMA = ['modalName']

export const trackUploadedPart = buildTracker(UPLOADED_PART, PART_SCHEMA)
export const trackOpenedChat = buildTracker(OPENED_CHAT)
export const trackOpenedModal = buildTracker(OPENED_MODAL, MODAL_SCHEMA)
